import ticketService from 'Services/TicketService'
import Vue from 'vue'

// initial state
const state = {
  tickets: [],
  comments: { }
}

// getters
const getters = {
  ticket: state => ticketId => state.tickets.find(ticket => ticket.ticketId === ticketId),
  ticketComments: state => ticketId => state.comments[ticketId] || [],
  ticketComment: (state, getters) => (ticketId, ticketCommentId) => getters.ticketComments(ticketId).find(comment => comment.ticketCommentId === ticketCommentId) || {}
}

const actions = {
  filterTickets: ({ commit }, { context, parameters }) => {
    const { request, cancelToken } = ticketService.getAll(context, parameters)

    const promise = new Promise((resolve, reject) => {
      request.then(result => {
        commit('setTickets', result.data)

        resolve(result)
      }).catch(error => {
        reject(error)
      })
    })

    return { promise, cancelToken }
  },

  getTickets: ({ dispatch }, { context }) => {
    return dispatch('filterTickets', { context }).then(({ promise }) => promise.then(result => result.data))
  },

  getTicket: ({ commit }, { context, ticketId }) => {
    return new Promise((resolve, reject) => {
      ticketService.get(context, ticketId).then(result => {
        commit(state.tickets.some(item => item.ticketId === result.ticketId) ? 'updateTicket' : 'setTicket', result)

        resolve(result)
      }).catch(error => {
        reject(error)
      })
    })
  },

  addTicket: ({ commit }, { context, ticket }) => {
    return new Promise((resolve, reject) => {
      ticketService.add(context, ticket).then((result) => {
        commit('setTicket', result)

        resolve(result)
      }).catch(error => {
        reject(error)
      })
    })
  },

  updateTicket: ({ dispatch }, { context, ticketId, ticket }) => {
    return new Promise((resolve, reject) => {
      ticketService.update(context, ticketId, ticket).then(() => {
        return dispatch('getTicket', { context, ticketId }).then(result => resolve(result))
      }).catch(error => {
        reject(error)
      })
    })
  },

  deleteTicket: ({ commit }, { context, ticketId }) => {
    return new Promise((resolve, reject) => {
      ticketService.delete(context, ticketId).then(() => {
        commit('deleteTicket', ticketId)

        resolve()
      }).catch(error => {
        reject(error)
      })
    })
  },

  getTicketComments: ({ commit, getters }, { context, ticketId, parameters, isAppending = false }) => {
    const { request, cancelToken } = ticketService.getTicketComments(context, ticketId, parameters)

    const promise = new Promise((resolve, reject) => {
      request.then(result => {
        const comments = getters.ticketComments(ticketId)
        commit('setComments', { ticketId, comments: isAppending ? comments.concat(result.data) : result.data })

        resolve(result)
      }).catch(error => {
        reject(error)
      })
    })

    return { promise, cancelToken }
  },

  getTicketComment: ({ commit }, { context, ticketId, ticketCommentId }) => {
    return new Promise((resolve, reject) => {
      ticketService.getTicketComment(context, ticketId, ticketCommentId).then(result => {
        commit(state.comments[ticketId].some(item => item.ticketCommentId === result.ticketCommentId) ? 'updateComment' : 'setComment', { ticketId, comment: result })

        resolve(result)
      }).catch(error => {
        reject(error)
      })
    })
  },

  addTicketComment: ({ commit }, { context, ticketId, ticketComment }) => {
    return new Promise((resolve, reject) => {
      ticketService.addTicketComment(context, ticketId, ticketComment).then(result => {
        commit('setComment', { ticketId, comment: result })

        resolve(result)
      }).catch(error => {
        reject(error)
      })
    })
  },

  updateTicketComment: ({ commit }, { context, ticketId, ticketCommentId, ticketComment }) => {
    return new Promise((resolve, reject) => {
      ticketService.updateTicketComment(context, ticketId, ticketCommentId, ticketComment).then(result => {
        commit('updateComment', { ticketId, comment: result })

        resolve(result)
      }).catch(error => {
        reject(error)
      })
    })
  },

  deleteTicketComment: ({ commit }, { context, ticketId, ticketCommentId }) => {
    return new Promise((resolve, reject) => {
      ticketService.deleteTicketComment(context, ticketId, ticketCommentId).then(() => {
        commit('deleteComment', { ticketId, ticketCommentId })

        resolve()
      }).catch(error => {
        reject(error)
      })
    })
  }
}

// mutations
const mutations = {
  setTickets (state, tickets) {
    state.tickets = tickets
  },

  setTicket (state, ticket) {
    state.tickets.push(ticket)
  },

  updateTicket (state, ticket) {
    state.tickets = state.tickets.map(item => item.ticketId === ticket.ticketId ? ticket : item)
  },

  deleteTicket (state, ticketId) {
    state.tickets = state.tickets.filter(ticket => ticket.ticketId !== ticketId)
  },

  setComments (state, { ticketId, comments }) {
    Vue.set(state.comments, ticketId, comments)
  },

  setComment (state, { ticketId, comment }) {
    if (typeof state.comments[ticketId] === 'undefined') {
      Vue.set(state.comments, ticketId, [])
    }

    state.comments[ticketId].unshift(comment)
  },

  updateComment (state, { ticketId, comment }) {
    Vue.set(state.comments, ticketId, state.comments[ticketId].map(item => item.ticketCommentId === comment.ticketCommentId ? comment : item))
  },

  deleteComment (state, { ticketId, ticketCommentId }) {
    Vue.set(state.comments, ticketId, state.comments[ticketId].filter(comment => comment.ticketCommentId !== ticketCommentId))
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
